import { React } from '../../react';

import cx from './style.less';

export interface IViewport {
    left: number;
    top: number;
    width: number;
    height: number;
}

export interface IViewportProps {
    children?: (viewport: IViewport) => any;
    className?: string;
    style?: any;
    styleClass?: string;
}

export class ScrollPanel extends React.PureComponent<IViewportProps, IViewport> {
    public state = {
        height: 0,
        left: 0,
        top: 0,
        width: 0,
    };

    private _container: HTMLDivElement;

    public componentDidMount() {
        this._container.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.onScroll);
        this.onScroll();
    }
    public componentWillUnmount() {
        this._container.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
    }

    public render() {
        return (
            <div className={cx('container', this.props.className)} 
                ref={this.setContainer} 
                style={this.props.style}
                >
                {this.props.children(this.state)}
            </div>
        );
    }

    private setContainer = (c: HTMLDivElement) => {
      this._container = c;
    }

    private onScroll = () => {
        const left = this._container.scrollLeft;
        const top = this._container.scrollTop;
        const width = this._container.clientWidth;
        const height = this._container.clientHeight;
        if (left !== this.state.left
            || top !== this.state.top
            || width !== this.state.width
            || height !== this.state.height) {
            this.setState({ left, top, width, height });
        }
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/scrollpanel/index.tsx